import * as React from 'react';
import { ArticleHeading3, UIText1 } from '@cian/ui-kit';

import { withEmptyRenderingStrict } from '../../utils/withEmptyRendering';
import * as style from './styles.css';

export interface ICommentPartProps {
  title?: string;
  message?: string | null;
}

export const CommentPartComponent: React.FC<ICommentPartProps> = ({ title, message }) => {
  return (
    <div data-testid="CommentPart" className={style['container']}>
      {!!title && (
        <div className={style['title']}>
          <ArticleHeading3>{title}</ArticleHeading3>
        </div>
      )}
      <div className={style['text']}>
        <UIText1>{message}</UIText1>
      </div>
    </div>
  );
};

export const CommentPart = withEmptyRenderingStrict<ICommentPartProps>(['message', 'title'])(CommentPartComponent);
